var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoDataCounsellors = function SvgNoDataCounsellors(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.4.1.0-RM-/-Counsellors",
    transform: "translate(-809, -415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/04.Confirmation/Empty-state",
    transform: "translate(697, 415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(112, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F1F1",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(20, 20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2083334,20 C23.8697917,20 22.5755208,19.4023437 21.5625,18.3177083 C20.577474,17.2597656 19.9759115,15.8489583 19.8697917,14.3463541 C19.7565104,12.7434895 20.2454427,11.2695312 21.2460938,10.1953125 C22.2467448,9.1210937 23.6458334,8.54166661 25.2083334,8.54166661 C26.7597657,8.54166661 28.1627605,9.13151036 29.1601563,10.203125 C30.1673178,11.2851562 30.6575521,12.7565104 30.5442709,14.3457031 L30.5442709,14.3457031 C30.4355469,15.8502604 29.8346355,17.2604167 28.8515625,18.3170573 C27.8411459,19.4023437 26.5475261,20 25.2083334,20 Z M25.2083334,22.0833333 C27.6074219,22.0833333 29.8307292,22.6692708 31.6347657,23.7792969 C33.6601563,25.0247396 35.0201824,26.8606771 35.5657553,29.0885417 C35.712337,29.671547 35.5847998,30.2895749 35.2194011,30.7669271 C34.8758378,31.2059154 34.3484547,31.4611938 33.7910157,31.4583593 L16.6263021,31.4583593 C16.0670013,31.4613271 15.537944,31.2047343 15.1940104,30.7636719 C14.829321,30.2857114 14.7031805,29.6672395 14.8515625,29.0846355 C15.3997396,26.8834636 16.7578125,25.0579427 18.7786458,23.8059896 C20.5722656,22.6953125 22.8554688,22.0833333 25.2083334,22.0833333 Z M12.9042968,21.468099 C14.546875,21.468099 16.0332031,21.7480469 17.1783854,22.3079427 C17.3118489,22.3730469 17.4290364,22.4361979 17.53125,22.4960938 C17.6831179,22.5851856 17.7796923,22.7449754 17.7879673,22.9208525 C17.7962423,23.0967296 17.7150976,23.264881 17.5722656,23.3678386 C15.6608073,24.733724 14.3671875,26.6074219 13.8151041,28.8248698 C13.8046875,28.8652344 13.7955729,28.90625 13.7884114,28.9472657 C13.7434182,29.1949219 13.5277518,29.3750171 13.2760416,29.3750171 L6.0494791,29.3750171 C5.5385881,29.3773223 5.05549422,29.1426286 4.74153638,28.7395834 C4.41078577,28.3068652 4.29592661,27.7467169 4.42968742,27.21875 C4.8808593,25.4069011 5.9980468,23.90625 7.6588541,22.8756511 C9.12369786,21.968099 10.9863281,21.468099 12.9042968,21.468099 Z M12.9036458,20.2604167 C10.6126302,20.2604167 8.59830723,18.1302083 8.41145828,15.5123698 C8.31901036,14.1712239 8.73697911,12.9309895 9.58333328,12.0214843 C10.4205729,11.1210937 11.6015625,10.625 12.9036458,10.625 C14.2057291,10.625 15.3776041,11.1236979 16.219401,12.0292968 C17.0722656,12.9459635 17.4889323,14.1835937 17.391276,15.5136719 C17.2044271,18.1308594 15.1907552,20.2604167 12.9036458,20.2604167 Z",
    id: "Combined-Shape",
    fill: "#999999",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoDataCounsellors, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data-counsellors.c3342ec0.svg";
export { ForwardRef as ReactComponent };